'use client';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

// ----------------------------------------------------------------------

export function GallerySkeleton() {
  return (
    <Stack sx={{ py: { xs: 0, sm: 1 } }}>
      <Skeleton
        sx={{
          borderRadius: { xs: 0, sm: 2 },
          pt: { xs: 'calc(100dvh - 70px)', sm: '100%' },
          backgroundColor: 'var(--palette-common-black)',
        }}
      />
    </Stack>
  );
}

export function ProductItemSkeleton({ sx, itemCount = 16, ...other }) {
  return Array.from({ length: itemCount }, (_, index) => (
    <Card
      key={index}
      className="scroll__snap__child"
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <GallerySkeleton />

      <Stack spacing={2} className="product__description" sx={{ px: 2, py: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row">
            <Skeleton variant="circular" sx={{ width: 16, height: 16 }} />
            <Skeleton variant="circular" sx={{ width: 16, height: 16 }} />
            <Skeleton variant="circular" sx={{ width: 16, height: 16 }} />
          </Stack>

          <Skeleton sx={{ width: 0.4, height: 16 }} />
        </Stack>

        <Skeleton sx={{ width: 0.7, height: 18 }} />
        <Skeleton sx={{ width: 1, height: 16 }} />
        <Skeleton sx={{ width: 0.5, height: 14 }} />
      </Stack>
    </Card>
  ));
}

export function HotSaleItemSkeleton({ sx, ...other }) {
  return (
    <Box sx={{ py: 0.5, mb: { xs: 1, md: 2 } }} {...other}>
      <Card>
        <Stack sx={{ p: 2 }} spacing={1}>
          <Skeleton sx={{ borderRadius: 0.5, pt: '100%' }} />

          <Stack direction="row" justifyContent="space-between" alignItems="end">
            <Skeleton sx={{ width: 0.6, height: 15 }} />
            <Skeleton variant="circular" sx={{ width: 28, height: 28 }} />
          </Stack>

          <Skeleton sx={{ width: 1, height: 14 }} />
          <Skeleton sx={{ width: 0.8, height: 12 }} />
        </Stack>
      </Card>
    </Box>
  );
}

export function ProductDetailsSkeleton({ ...other }) {
  return (
    <Grid container spacing={8} rowSpacing={{ xs: 0, md: 8 }} {...other}>
      <Grid size={{ xs: 12, md: 6, lg: 7 }}>
        <Skeleton sx={{ pt: '100%' }} />
      </Grid>

      <Grid size={{ xs: 12, md: 6, lg: 5 }} sx={{ my: { xs: 6, md: 0 } }}>
        <Stack spacing={3}>
          <Skeleton sx={{ height: 14, width: 0.45 }} />
          <Skeleton sx={{ height: 22, width: 0.75 }} />
          <Skeleton sx={{ height: 18, width: 0.5 }} />
          <Skeleton sx={{ height: 24, width: 0.25 }} />

          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ py: 3 }}
          >
            <Skeleton sx={{ height: 16, width: 0.2 }} />
            <Skeleton sx={{ height: 45, width: 0.25 }} />
          </Stack>

          <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
            <Skeleton sx={{ height: 45, width: 0.45 }} />
            <Skeleton sx={{ height: 45, width: 0.45 }} />
          </Stack>

          <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-around">
            <Skeleton sx={{ height: 16, width: 0.35 }} />
            <Skeleton sx={{ height: 16, width: 0.35 }} />
          </Stack>

          <Stack alignItems="center">
            {Array.from({ length: 2 }, (_, index) => (
              <Stack
                key={index}
                spacing={2}
                direction="row"
                alignItems="center"
                sx={{ width: 1, py: 2 }}
              >
                <Skeleton variant="circular" sx={{ width: 36, height: 36 }} />

                <Stack spacing={1}>
                  <Skeleton sx={{ height: 16, width: 160 }} />
                  <Skeleton sx={{ height: 12, width: 260 }} />
                </Stack>
              </Stack>
            ))}
          </Stack>

          <Skeleton sx={{ height: 180 }} />
        </Stack>
      </Grid>

      <Grid size={12}>
        <Skeleton sx={{ height: 180 }} />
      </Grid>
    </Grid>
  );
}
